import {useDispatch, useSelector} from 'react-redux';
import type {RootState} from '@/store';
import type {InAutoCaptionModeType} from '@Components/social-media/social-media.types';
import {setInAutoCaptionMode} from '@/reducers/auto-caption-reducer';

interface UseAutoCaptionCommonType {
  inAutoCaptionMode: InAutoCaptionModeType;
  setInAutoCaptionMode: (inAutoCaptionMode: InAutoCaptionModeType) => void;
  closeAutoCaptionMode: VoidFunction;
}

const useAutoCaptionGlobal = (): UseAutoCaptionCommonType => {
  const dispatch = useDispatch();

  const autoCaptionStateInRedux = useSelector((state: RootState) => {
    return state.autoCaption;
  });

  const inAutoCaptionModeInRedux = autoCaptionStateInRedux.inAutoCaptionMode;

  const setInAutoCaptionModeInRedux = (isAutoCaptionMode: InAutoCaptionModeType): void => {
    dispatch(setInAutoCaptionMode(isAutoCaptionMode));
  };

  const closeAutoCaptionMode = (): void => {
    setInAutoCaptionModeInRedux({accountId: null});
  };

  return {
    inAutoCaptionMode: inAutoCaptionModeInRedux,
    setInAutoCaptionMode: setInAutoCaptionModeInRedux,
    closeAutoCaptionMode,
  };
};

export default useAutoCaptionGlobal;
